import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Growl } from "primereact/growl";
import { InputText } from "primereact/inputtext";
import React, { Component } from "react";
import { trackPromise } from "react-promise-tracker";
import { HttpService } from "../service/HttpService";
import { checkForError, showMessage } from "../utility/AppUtility";
import { AppBreadcrumb } from "../AppBreadcrumb";
import moment from "moment";
import _ from "lodash";


export class ConsignmentCodeList extends Component {
  constructor() {
    super();
    this.state = {
      dataTableValue: [],
      page: 1,
      totalRecords: 0,
      size: 10,
      expandedRows: null,
      first: 0,

       filters: {
      reference: "",
      noOfBox: "",
      overallStatus: "",
      sendingDate: "",
    },

    };

    this.httpService = new HttpService();
    this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);

     this.handleFilterChange = _.debounce(() => {
    this.getList(0);
  }, 400);

  }

  componentDidMount() {
    this.getList(this.state.page - 1);
  }



  getList = (page) => {
  const { filters, size } = this.state;

  let params =
    "page=" + page +
    "&size=" + size +
    "&sort=createdDate,desc";

  if (filters.reference)
    params += `&reference=${filters.reference}`;

  if (filters.noOfBox)
    params += `&noOfBox=${filters.noOfBox}`;

  if (filters.overallStatus)
    params += `&overallStatus=${filters.overallStatus}`;

  if (filters.sendingDate)
    params += `&sendingDate=${filters.sendingDate}`;

  trackPromise(
    this.httpService
      .getApi("v1/consignment/get_all_fcodes?" + params)
      .then((response) => {
        this.setState({
          dataTableValue: response.data.content,
          totalRecords: response.data.totalElements,
          page: page + 1,
          first: page * size,
        });
      })
      .catch((error) => {
        if (checkForError(error))
          this.showMessage(
            "error",
            "Error Message",
            error.response.data.title
          );
      })
  );
};

    handleColumnFilterChange = (field, value) => {
  this.setState(
    {
      filters: {
        ...this.state.filters,
        [field]: value,
      },
      page: 1,
      first: 0,
    },
    () => this.handleFilterChange()
  );
};




  showMessage(severity, summary, message) {
    let msg = { severity: severity, summary: summary, detail: message };
    this.growl.show(msg);
  }
  onPageChange = (event) => {
    this.setState({
      page: event.page,
      first: event.first
    });
    this.getList(event.page);
  };

  rowExpansionTemplate(data) {
    return (
      <div className="orders-subtable">
        <h4>List of F-Codes</h4>
        <DataTable value={data.palletLabels.reverse()}>
          <Column field="label" header="F-Code" sortable></Column>
        </DataTable>
      </div>
    );
  }

  returnHeader = () => {
    return (
      <div>
        <div>Consignments</div>

        <div className="p-datatable-globalfilter-container">
          <InputText
            type="search"
            onInput={(e) => this.setState({ globalFilter: e.target.value })}
            placeholder="Global Search"
          />
        </div>
      </div>
    );
  };

  returnValue = (rowData) => {
    return moment(new Date(rowData.sendingDate))
      .format("DD-MM-YY hh:mm a")
      .toString();
  };

  expandAll() {
    let expandedRows = {};
    this.state.dataTableValue.forEach((p) => (expandedRows[`${p.id}`] = true));
    this.setState({ expandedRows });
  }

  collapseAll() {
    this.setState({
      expandedRows: null,
    });
  }
  render() {
    let actionHeader = <Button type="button" icon="pi-md-settings" />;

    return (
      <>
        <AppBreadcrumb breadcrumdItems={[{ label: "Consignment List" }]} />
        <div className="p-grid">
          <div className="p-col-12">
            <Growl
              ref={(el) => (this.growl = el)}
              style={{ marginTop: "75px" }}
            />

            <div className=" datatable-demo">
              <div className="p-col-12">
                <font className="font21Weight500">Consignment</font>
              </div>
              <div className="p-col-12"></div>




              <DataTable
  ref={(el) => (this.dt = el)}
  value={this.state.dataTableValue}
  rowExpansionTemplate={this.rowExpansionTemplate}
  paginator
  dataKey="id"
  expandedRows={this.state.expandedRows}
  rows={10}
  header="List of Consignments"
  onRowToggle={(e) => this.setState({ expandedRows: e.data })}
  responsive
  resizableColumns
  columnResizeMode="fit"
  lazy
  first={this.state.first}
  totalRecords={this.state.totalRecords}
  onPage={(event) => this.onPageChange(event)}
>
  <Column expander style={{ width: "3em" }} />

  <Column
    field="reference"
    header={
      <div>
        <div>Ref. No.</div>
        <InputText
          value={this.state.filters.reference}
          onChange={(e) =>
            this.handleColumnFilterChange("reference", e.target.value)
          }
          placeholder="Reference"
        />
      </div>
    }
   // sortable
  />

  <Column
    field="noOfBox"
    header={
      <div>
        <div>Items</div>
        <InputText
          value={this.state.filters.noOfBox}
          onChange={(e) =>
            this.handleColumnFilterChange("noOfBox", e.target.value)
          }
          placeholder="No of Box"
        />
      </div>
    }
   // sortable
  />

  <Column
    field="overallStatus"
    header={
      <div>
        <div>Status</div>
        <InputText
          value={this.state.filters.overallStatus}
          onChange={(e) =>
            this.handleColumnFilterChange("overallStatus", e.target.value)
          }
          placeholder="Status"
        />
      </div>
    }
    //sortable
  />

  <Column
    field="sendingDate"
    header={
      <div>
        <div>Created Date</div>
        <InputText
          value={this.state.filters.sendingDate}
          onChange={(e) =>
            this.handleColumnFilterChange("sendingDate", e.target.value)
          }
          placeholder="YYYY-MM-DD"
        />
      </div>
    }
    //sortable
  />
</DataTable>






            </div>
          </div>
        </div>
      </>
    );
  }
}
